import { render, staticRenderFns } from "./TestView.vue?vue&type=template&id=077e1395&scoped=true&"
import script from "./TestView.vue?vue&type=script&lang=js&"
export * from "./TestView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077e1395",
  null
  
)

export default component.exports